import React from 'react';

const closeButton = (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31">
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 31h30V.999H0z" />
      <path stroke="#6C7378" strokeLinecap="round" d="M6.5 7.5l17 17M6.5 24.5l17-17" />
    </g>
  </svg>
);

export default closeButton;



// WEBPACK FOOTER //
// ./home/img/close-30-grey.js